/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online UUID and ULID inspector. Paste an identifier to validate it, read its version and variant, and decode the embedded timestamp (v1, v7, ULID). Works in your browser.`)
};

const es_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector en línea gratuito de UUID e ULID. Pega un identificador para validarlo, lee su versión y variante, y decodifica la marca de tiempo incorporada (v1, v7, ULID). Funciona en tu navegador.`)
};

const de_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-UUID- und ULID-Inspector. Fügen Sie eine Kennung ein, um sie zu validieren, ihre Version und Variante abzulesen und den eingebetteten Zeitstempel zu decodieren (v1, v7, ULID). Funktioniert direkt in Ihrem Browser.`)
};

const nl_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online UUID en ULID inspector. Plak een identificatie om deze te valideren, lees de versie en variant en decodeer de ingebouwde tijdstempel (v1, v7, ULID). Werkt in je browser.`)
};

const fr_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur UUID et ULID en ligne gratuit. Collez un identifiant pour le valider, lire sa version et sa variante, et décoder l'horodatage intégré (v1, v7, ULID). Fonctionne dans votre navigateur.`)
};

const it_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ispettore gratuito online di UUID e ULID. Incolla un identificatore per convalidarlo, leggi la sua versione e variante, e decodifica il timestamp incorporato (v1, v7, ULID). Funziona nel tuo browser.`)
};

const pt_br2_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor gratuito de UUID e ULID online. Cole um identificador para validá-lo, leia sua versão e variante, e decodifique o timestamp incorporado (v1, v7, ULID). Funciona no seu navegador.`)
};

const pt_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor gratuito de UUID e ULID em linha. Cole um identificador para o validar, leia a sua versão e variante e descodifique o timestamp incorporado (v1, v7, ULID). Funciona no seu navegador.`)
};

const ja_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン UUID & ULID インスペクター。識別子を貼り付けて検証し、バージョンとバリアントを読み取り、埋め込みタイムスタンプ (v1, v7, ULID) をデコードします。ブラウザで動作します。`)
};

const zh_ud_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线 UUID 与 ULID 检查器。粘贴标识符即可验证,读取其版本和变体,并解码内嵌的时间戳(v1、v7、ULID)。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_meta_description", locale)
	if (locale === "en") return en_ud_meta_description(inputs)
	if (locale === "es") return es_ud_meta_description(inputs)
	if (locale === "de") return de_ud_meta_description(inputs)
	if (locale === "nl") return nl_ud_meta_description(inputs)
	if (locale === "fr") return fr_ud_meta_description(inputs)
	if (locale === "it") return it_ud_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ud_meta_description(inputs)
	if (locale === "pt") return pt_ud_meta_description(inputs)
	if (locale === "ja") return ja_ud_meta_description(inputs)
	return zh_ud_meta_description(inputs)
};